import addToBasketTemplate from './modal-ukrail-add-to-basket.html';
import doErrorMsgTemplate from './delivery-option-error-msg.html';
import {SIZE_MEDIUM} from '../../common/modal/modal-service';

export default function RailResultController(
    $scope,
    $controller,
    modalService,
    railsFactory
) {
    'ngInject';
    $controller('UkrailResultBaseController', {
        $scope,
        railsFactory,
    });

    const vm = this;

    Object.assign(vm, {
        openAddToBasketPopup,
        isPreferenceVisible,
    });

    function openAddToBasketPopup() {
        $scope.resetTravelOptions();
        $scope.setDeliveryOptionValues();
        $scope.addToBasketPopup = modalService.openModal({
            template: ($scope.unavailableDO ? doErrorMsgTemplate : addToBasketTemplate),
            scope: $scope,
            size: SIZE_MEDIUM,
        });
    }

    function isPreferenceVisible(preferenceCode) {
        const options = [
            ...$scope.options.RRPreferenceOptionsNearPreferences,
            ...$scope.options.RRPreferenceOptionsNearPhysicalRequirements,
        ];

        return options.some(({Code: code}) => code === preferenceCode);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/controllers/ukrailResultCtrl.js